import type { ExpenseCostSplit } from '../../api';
import {
  ISSUE_PERFORMER_OPTIONS,
  performerNamePlaceholder,
  performerNeedsName,
  type MaintenancePerformerType,
} from '../../utils/aircraftMaintenance';
import { OWNER_SPLITS } from '../../utils/expenseSplit';
import { parseIssueCost } from '../../utils/issueDisplay';
import ExpenseSplitFields from '../ExpenseSplitFields/ExpenseSplitFields';
import './IssueResolveFields.css';

type Props = {
  resolvedDate: string;
  performerType: MaintenancePerformerType;
  performerName: string;
  cost: string;
  costSplit: ExpenseCostSplit;
  manualShares: Record<number, string>;
  flightIds?: number[];
  allowedSplits?: ExpenseCostSplit[];
  onPerformerTypeChange: (value: MaintenancePerformerType) => void;
  onPerformerNameChange: (value: string) => void;
  onCostChange: (value: string) => void;
  onCostSplitChange: (value: ExpenseCostSplit) => void;
  onManualSharesChange: (value: Record<number, string>) => void;
  onFlightIdsChange?: (value: number[]) => void;
};

const IssueResolveFields = ({
  resolvedDate,
  performerType,
  performerName,
  cost,
  costSplit,
  manualShares,
  flightIds = [],
  allowedSplits = OWNER_SPLITS,
  onPerformerTypeChange,
  onPerformerNameChange,
  onCostChange,
  onCostSplitChange,
  onManualSharesChange,
  onFlightIdsChange = () => undefined,
}: Props) => {
  const parsed = parseIssueCost(cost);
  const amount = parsed.ok && parsed.value > 0 ? parsed.value : null;

  return (
    <>
      <label>Кем устранена</label>
      <select
        value={performerType}
        onChange={(e) =>
          onPerformerTypeChange(e.target.value as MaintenancePerformerType)
        }
      >
        <option value="">Не указано</option>
        {ISSUE_PERFORMER_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {performerNeedsName(performerType) ? (
        <>
          <label>{performerNamePlaceholder(performerType)}</label>
          <input
            type="text"
            value={performerName}
            onChange={(e) => onPerformerNameChange(e.target.value)}
            maxLength={80}
            placeholder={performerNamePlaceholder(performerType)}
          />
        </>
      ) : null}

      <label>Стоимость, ₽</label>
      <input
        type="text"
        inputMode="decimal"
        autoComplete="off"
        value={cost}
        onChange={(e) => onCostChange(e.target.value)}
      />
      <p className="issue-resolve-hint">0 — устранение без расхода</p>

      {amount != null ? (
        <ExpenseSplitFields
          date={resolvedDate}
          amount={amount}
          expenseType="repair"
          costSplit={costSplit}
          manualShares={manualShares}
          flightIds={flightIds}
          onCostSplitChange={onCostSplitChange}
          onManualSharesChange={onManualSharesChange}
          onFlightIdsChange={onFlightIdsChange}
          radioName="issue-cost-split"
          allowedSplits={allowedSplits}
        />
      ) : null}
    </>
  );
};

export default IssueResolveFields;
